import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { scenes, getSceneName } from "@/consts/consts.ts";
let Footer = class Footer extends Vue {
    constructor() {
        super(...arguments);
        this.scenes = scenes;
    }
    sceneList() {
        const scene = [scenes.PROLOGUE];
        if (this.cleared >= scenes.BOARD) {
            scene.push(scenes.BOARD);
        }
        if (this.cleared >= scenes.BANK) {
            scene.push(scenes.BANK);
        }
        if (this.cleared >= scenes.CASINO) {
            scene.push(scenes.CASINO);
        }
        if (this.cleared >= scenes.HOTEL) {
            scene.push(scenes.HOTEL);
        }
        if (this.cleared >= scenes.APART) {
            scene.push(scenes.APART);
        }
        if (this.cleared >= scenes.CASTLE) {
            scene.push(scenes.CASTLE);
        }
        return scene;
    }
    sceneName(sceneNumber) {
        return getSceneName(sceneNumber);
    }
    select(sceneNumber) {
        this.selectScene(sceneNumber);
    }
};
__decorate([
    Prop()
], Footer.prototype, "cleared", void 0);
__decorate([
    Prop()
], Footer.prototype, "selected", void 0);
__decorate([
    Prop()
], Footer.prototype, "player", void 0);
__decorate([
    Prop()
], Footer.prototype, "selectScene", void 0);
Footer = __decorate([
    Component
], Footer);
export default Footer;
